module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? [_c('h1', [_vm._v("Chargement...")])] : (_vm.notFound) ? [_c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v("\n      Ce dossier n'existe pas."), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Aller sur la page principale")])], 1)] : [_c('h1', [_vm._v("Dossier " + _vm._s(_vm.directoryName))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.files.length) + " fichier(s) (" + _vm._s(_vm.directorySize) + ")")]), _vm._v(" "), _c('a', {
    staticClass: "button is-small",
    attrs: {
      "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId + "/files/download"),
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Télécharger tout")])]), _vm._v(" "), _c('ul', {
    staticClass: "block"
  }, _vm._l((_vm.files), function(file) {
    return _c('li', [_vm._v("\n        " + _vm._s(file.realName) + " (" + _vm._s(file.size) + ")"), _c('br'), _vm._v(" "), _c('code', [_c('a', {
      attrs: {
        "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId + "/" + (file.name)),
        "id": ("file-" + _vm.directoryId + "-address"),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.rootUrl) + "/dossier/" + _vm._s(_vm.directoryId) + "/" + _vm._s(file.name))])]), _vm._v(" "), _c('a', {
      staticClass: "button is-small copiable",
      attrs: {
        "data-clipboard-target": ("#file-" + _vm.directoryId + "-address")
      }
    }, [_c('span', [_vm._v("Copier")])]), _vm._v(" "), _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId + "/" + (file.name)),
        "target": "_blank"
      }
    }, [_c('span', [_vm._v("Ouvrir")])]), _vm._v(" "), _c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": (_vm.rootUrl + "/dossier/" + _vm.directoryId + "/" + (file.name) + "?download"),
        "target": "_blank"
      }
    }, [_c('span', [_vm._v("Télécharger")])])])
  })), _vm._v(" "), _c('span')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bcaada0!./~/vue-loader/lib/selector.js?type=template&index=0!./app/src/components/pages/Directory.vue
// module id = 130
// module chunks = 0